import { FC } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';
import {
  MenuForm,
  StartDateForm,
  EndDateForm,
  ValidForm,
} from 'page/CustomerPage/components/ContractForms';
import { OriginalMenu } from 'types/menu';
import { ReadonlyForm } from 'components/molecules/ReadonlyForm';

type Props = {
  formState: FormState<ContractFormFields>;
  isOpen: boolean;
  isButtonDisabled: boolean;
  contractId: number | undefined;
  startDate: string;
  endDate: string;
  uncontractedMenusAddedCurrentMenu: OriginalMenu[];
  register: UseFormRegister<ContractFormFields>;
  changeStartDate: (startDate: string) => void;
  changeEndDate: (endDate: string) => void;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
  handleClickGoDelete: () => void;
};

export const InputModalView: FC<Props> = ({
  formState,
  isOpen,
  isButtonDisabled,
  contractId,
  startDate,
  endDate,
  uncontractedMenusAddedCurrentMenu,
  register,
  changeStartDate,
  changeEndDate,
  handleClose,
  handleClickGoConfirmation,
  handleClickGoDelete,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="2xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
    isCentered
  >
    <ModalOverlay />
    <ModalContent h="60vh" minH="750px">
      <ModalHeader p="40px 40px 0 40px">契約メニューの更新</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {/* 契約ID */}
        <Box mt="40px">
          <ReadonlyForm
            label="契約 ID"
            boldLabel={false}
            value={contractId ? contractId.toString() : ''}
          />
        </Box>
        {/* メニューID */}
        <Box mt="40px">
          <MenuForm
            menus={uncontractedMenusAddedCurrentMenu}
            register={register}
            error={formState.errors.menuId}
          />
        </Box>
        {/* 有効 / 無効 */}
        <Box mt="40px">
          <ValidForm register={register} error={formState.errors.valid} />
        </Box>
        {/* 契約開始日 */}
        <Box mt="40px">
          <StartDateForm
            initialDate={startDate}
            handleChangeDate={(date) => changeStartDate(date)}
          />
        </Box>
        {/* 契約終了日 */}
        <Box mt="40px">
          <EndDateForm
            initialDate={endDate}
            handleChangeDate={(date) => changeEndDate(date)}
          />
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <Stack gap="40px">
          <Button
            width="140px"
            colorScheme="blackAlpha"
            mr={3}
            onClick={handleClickGoConfirmation}
            isDisabled={isButtonDisabled}
          >
            確認
          </Button>

          <Button
            width="140px"
            colorScheme="blackAlpha"
            variant="link"
            mr={3}
            onClick={handleClickGoDelete}
          >
            この契約メニューを削除
          </Button>
        </Stack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
